<div [innerHTML]="info" style="white-space: pre;"></div>

<!-- <form>
    <mat-form-field appearance="fill">
        <mat-label>Default</mat-label>
        <input #lotNbrInputField1 matInput (keyup.enter)="onLotTEST0($event)" placeholder="TEST 0" />
    </mat-form-field><br />

    <mat-form-field appearance="fill">
        <mat-label>inputmode='none'</mat-label>
        <input #lotNbrInputField1 matInput (keyup.enter)="onLotTEST1($event)" placeholder="TEST 1" inputmode="none" />
    </mat-form-field><br />
 -->
    <!-- <mat-form-field appearance="fill">
        <mat-label>Lot #</mat-label>
        <input #lotNbrField matInput scanInput2="LOT" (scanned)="onLotTEST2($event, lotNbrField)"
            (focus)="info = '<table>'" placeholder="ABC - 12345678" />
    </mat-form-field>
    <span>&nbsp;</span>
    <mat-form-field appearance="fill">
        <mat-label>Qty</mat-label>
        <input #qtyField matInput inputmode="none" />
    </mat-form-field> -->
<!-- </form> -->

<!-- <form>
    <mat-form-field appearance="fill">
        <mat-label>Allowed Keyboard</mat-label>
        <input #lotNbrInputField2 matInput scanInput2="LOT" allowKeyboard placeholder="TEST 2" />
    </mat-form-field>
</form> -->

<inventory-id-selector #itemSelector (onSubmit)="barcodeValidation($event)" (onChange)="processScannedBarcode($event)"
    [search]="true" [searchWhse]="'03'"></inventory-id-selector>

<hr />
<div
    (click)="window.open('https://erp.nhook.com:10443/MPF21R2/?ScreenId=SO301000&OrderType=SO&OrderNbr=' + this.devsonbr, '_salesorder')">
    {{devsonbr}}
</div>
<div
    (click)="window.open('https://erp.nhook.com:10443/MPF21R2/?ScreenId=SO302000&ShipmentNbr=' + this.devshnbr, '_shipment')">
    {{devshnbr}}</div>
<button mat-raised-button color="primary" type="button" (click)="promptCreateTestSO()">Create Test</button>
<button mat-raised-button color="primary" type="button" (click)="deletePrevTest()">Delete Prev Test</button><br />
<mat-slide-toggle [checked]="navigateToTest" (change)="navigateToTest = $event.checked;">Navigate to new Tests
</mat-slide-toggle>

<hr />
<button mat-raised-button color="primary" type="button" (click)="do_the_error()">Do the error</button>
<button mat-raised-button color="primary" type="button" (click)="do_the_thing()">Do the thing</button>

<hr />
Backend Logging is {{logger.enabled ? 'Enabled' : 'Disabled'}}<br />
Viewport size: {{innerWidth}} x {{innerHeight}}

<ng-template #forTest let-data>
    <h2 mat-dialog-title>{{data.title}}</h2>

    <div *ngFor="let item of data.items">{{item.key}} - {{item.phonic}}</div>
    <div mat-dialog-actions>
        <button mat-raised-button [mat-dialog-close]>OK</button>
    </div>
</ng-template>

<ng-template #createTestSOType>
    <form [formGroup]="createSOUnitTestFormGroup">
        <mat-dialog-content>
            Test Order Type:
            <mat-select formControlName="SOUnitTestIndex">
                <mat-option *ngFor="let unitTest of SOUnitTests; let idx=index" [value]="idx">
                    {{unitTest.description}}
                </mat-option>
            </mat-select>
        </mat-dialog-content>
        <mat-dialog-actions style="justify-content: space-between;">
            <button matSuffix mat-raised-button [mat-dialog-close]="false">Cancel</button>
            <button matSuffix mat-raised-button color="primary" [mat-dialog-close]="true" type="submit"
                style="justify-content: flex-end;">OK</button>
        </mat-dialog-actions>
    </form>
</ng-template>